"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStateEnum = void 0;
var OrderStateEnum;
(function (OrderStateEnum) {
    OrderStateEnum[OrderStateEnum["PreOrder"] = 1] = "PreOrder";
    OrderStateEnum[OrderStateEnum["Confirmed"] = 2] = "Confirmed";
    OrderStateEnum[OrderStateEnum["Taked"] = 3] = "Taked";
    OrderStateEnum[OrderStateEnum["WaitForCustomer"] = 9] = "WaitForCustomer";
    OrderStateEnum[OrderStateEnum["MoveToOrder"] = 10] = "MoveToOrder";
    OrderStateEnum[OrderStateEnum["WaitLoading"] = 11] = "WaitLoading";
    OrderStateEnum[OrderStateEnum["MoveByOrder"] = 12] = "MoveByOrder";
    OrderStateEnum[OrderStateEnum["WaitUnloading"] = 13] = "WaitUnloading";
    OrderStateEnum[OrderStateEnum["WaitPayOnline"] = 19] = "WaitPayOnline";
    OrderStateEnum[OrderStateEnum["WaitPay"] = 20] = "WaitPay";
    OrderStateEnum[OrderStateEnum["Executed"] = 21] = "Executed";
    OrderStateEnum[OrderStateEnum["ExecutedConfirmed"] = 22] = "ExecutedConfirmed";
    OrderStateEnum[OrderStateEnum["ExecutedUnconfirmed"] = 23] = "ExecutedUnconfirmed";
    OrderStateEnum[OrderStateEnum["CancelByManager"] = 30] = "CancelByManager";
    OrderStateEnum[OrderStateEnum["CancelByCustomer"] = 31] = "CancelByCustomer";
    OrderStateEnum[OrderStateEnum["CancelByDriver"] = 32] = "CancelByDriver";
})(OrderStateEnum || (exports.OrderStateEnum = OrderStateEnum = {}));
//# sourceMappingURL=OrderStateEnum.js.map